import { render, staticRenderFns } from "./UEditorRichText.vue?vue&type=template&id=eb9ecbf8"
import script from "./UEditorRichText.vue?vue&type=script&lang=js"
export * from "./UEditorRichText.vue?vue&type=script&lang=js"
import style0 from "./UEditorRichText.vue?vue&type=style&index=0&id=eb9ecbf8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports